module.exports = __webpack_public_path__ + "static/media/wind_gust_1.4c31794d.png";